const Spinner = () => {
  return (
    <div className="relative w-[50px] h-[50px] flex items-center justify-center">
      {/* Centered Static SVG */}
      <div className="absolute z-10">
        <svg
          className="w-[20px] h-[24px]"
          viewBox="0 0 42 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.2648 39.3L4.60803 40.1974L1.02915 42.1336L0.918701 42.1959L0.918701 41.4386C0.918701 40.2582 1.82925 39.3015 2.95261 39.3015L6.2648 39.3015V39.3Z"
            fill="#0A3690"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.841797 50.5596C14.4732 49.3866 25.18 38.677 25.18 25.6865C25.18 12.6946 14.4732 1.98645 0.841797 0.813477L0.841797 10.6005C9.09084 11.6815 15.4453 18.0346 15.4453 25.6865C15.4453 31.4895 11.7907 36.5454 6.42679 39.1215H3.32927C2.28802 39.1215 1.39627 39.7936 1.02551 40.7475C0.964378 40.7561 0.90314 40.7645 0.841797 40.7725L0.841797 41.7352L0.841797 42.6613L0.841797 50.5596Z"
            fill="#0A3690"
          />
          <path
            opacity="0.9"
            d="M41.6828 20.134C41.6828 30.7955 33.0092 39.469 22.3449 39.469L2.97736 39.469C1.79731 39.469 0.84082 40.4255 0.84082 41.6055L0.84082 29.7329L22.3449 29.7329C27.6396 29.7329 31.948 25.4258 31.948 20.1326C31.948 14.8393 27.641 10.5294 22.3449 10.5294L0.84082 10.5294L0.84082 0.796143L22.3449 0.796143C33.0092 0.796143 41.6828 9.46966 41.6828 20.134Z"
            fill="url(#paint0_linear_11399_2622)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_11399_2622"
              x1="37.4452"
              y1="3.62299"
              x2="-11.5726"
              y2="37.9884"
              gradientUnits="userSpaceOnUse">
              <stop
                offset="0.317708"
                stopColor="#02C9A8"
              />
              <stop
                offset="1"
                stopColor="#ABC7FF"
              />
            </linearGradient>
          </defs>
        </svg>
      </div>

      {/* Spinning Gradient Ring */}
      <div className="w-[50px] h-[50px] animate-spin bg-gradient-to-r from-[#12ccae] via-[#1bceb1] to-[#0a3690] rounded-full flex items-center justify-center">
        <div className="w-[40px] h-[40px] bg-white rounded-full"></div>
      </div>
    </div>
  );
};

export default Spinner;
